import React from 'react';
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  createColumnHelper,
} from '@tanstack/react-table';

const columnHelper = createColumnHelper();

const columns = [
  columnHelper.accessor((row) => row?.[0], {
    id: 'state',
    header: 'State',
    cell: (info) => info.getValue() ?? '',
  }),
  columnHelper.accessor((row) => row?.[1], {
    id: 'dealer',
    header: 'Dealer Name',
    cell: (info) => info.getValue() ?? '',
  }),
  columnHelper.accessor((row) => row?.[2], {
    id: 'customer',
    header: 'Customer Name',
    cell: (info) => info.getValue() ?? '',
  }),
  columnHelper.accessor((row) => row?.[3], {
    id: 'startDate',
    header: 'Start Date',
    cell: (info) => info.getValue() ?? '',
  }),
  columnHelper.accessor((row) => row?.[4], {
    id: 'endDate',
    header: 'End Date',
    cell: (info) => info.getValue() ?? '',
  }),
  columnHelper.accessor((row) => row?.[5], {
    id: 'count',
    header: 'Count',
    cell: (info) => info.getValue() ?? '',
  }),
];

const Vehicletable = ({ data }) => {
  const table = useReactTable({
    data: data ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="overflow-x-auto border rounded">
      <div className="max-h-[350px] overflow-y-auto">
        <table className="min-w-max w-full border text-sm">
          <thead className="bg-gray-100 sticky top-0 z-10">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border px-3 py-2 text-left  font-medium bg-gray-300 whitespace-nowrap"
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row, rowIndex) => (
              <tr key={row.id} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="border px-3 py-2 whitespace-nowrap text-left"
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Vehicletable;
